export default "__VITE_ASSET__BizM556d__"